module.exports = __webpack_public_path__ + "static/img/lots_icon.c4a898cc.png";